module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "navbar col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "tag": "div",
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.global.name))]), _vm._v(" "), _c('div', {
    staticClass: "navbar-collopse",
    class: {
      'nav-open': _vm.is_open === 1
    }
  }, [_c('button', {
    staticClass: "collopse-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.is_open = -_vm.is_open
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav clearfix left",
    on: {
      "click": function($event) {
        _vm.is_open = -_vm.is_open
      }
    }
  }, [(!_vm.authorized || (_vm.viewType === 1 && _vm.user.category === 1)) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": "/evaluate",
      "active-class": "active"
    }
  }, [_vm._v("测评中心")]) : _vm._e(), _vm._v(" "), (_vm.authorized && (_vm.user.role === 2 || _vm.user.role === 3) && _vm.viewType === 1) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": "/company",
      "active-class": "active"
    }
  }, [_vm._v("企业控制台")]) : _vm._e(), _vm._v(" "), (_vm.authorized && (_vm.user.category === 2 || _vm.user.role === 2 || _vm.user.role === 3) && _vm.viewType === 2) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": "/company/dashboard",
      "active-class": "active"
    }
  }, [_vm._v("控制台")]) : _vm._e(), _vm._v(" "), (_vm.authorized && _vm.user.category === 2 && _vm.viewType === 2) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": "/company/organizations",
      "active-class": "active"
    }
  }, [_vm._v("组织结构")]) : _vm._e(), _vm._v(" "), (_vm.authorized && _vm.user.category === 2 && _vm.viewType === 2) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": "/company/hr",
      "active-class": "active"
    }
  }, [_vm._v("HR管理")]) : _vm._e(), _vm._v(" "), (_vm.authorized && (_vm.user.category === 2 || _vm.user.role === 2 || _vm.user.role === 3) && _vm.viewType === 2) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": "/company/posts",
      "active-class": "active"
    }
  }, [_vm._v("岗位管理")]) : _vm._e(), _vm._v(" "), (_vm.authorized && (_vm.user.category === 2 || _vm.user.role === 2 || _vm.user.role === 3) && _vm.viewType === 2) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": "/company/invitations",
      "active-class": "active"
    }
  }, [_vm._v("测评邀请")]) : _vm._e(), _vm._v(" "), (_vm.authorized && _vm.user.category === 2 && _vm.viewType === 2) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": "/company/setting",
      "active-class": "active"
    }
  }, [_vm._v("企业设置")]) : _vm._e(), _vm._v(" "), (_vm.authorized && _vm.user.category === 1) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": "/user",
      "active-class": "active"
    }
  }, [_vm._v("个人中心")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "user right n-p-r"
  }, [(_vm.authorized) ? _c('div', [_c('div', {
    staticClass: "user-info right"
  }, [(_vm.user.category === 1 && _vm.viewType === 1) ? _c('router-link', {
    attrs: {
      "to": "/user"
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.user.avatar,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.user.nickname + (_vm.user.role === 1 ? '' : '-' + (_vm.user.company.short_name || _vm.user.company.name))))])]) : _vm._e(), _vm._v(" "), (_vm.user.category === 1 && (_vm.user.role === 2 || _vm.user.role === 3) && _vm.viewType === 2) ? _c('router-link', {
    attrs: {
      "to": "/company"
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.user.company.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.user.company.short_name || _vm.user.company.name))])]) : _vm._e(), _vm._v(" "), (_vm.user.category === 2) ? _c('router-link', {
    attrs: {
      "to": "/company"
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.user.user_company.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.user.user_company.short_name || _vm.user.user_company.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-actions"
  }, [(!(_vm.user.category === 1 && (_vm.user.role === 2 || _vm.user.role === 3) && _vm.viewType === 2)) ? _c('div', {
    staticClass: "action",
    on: {
      "click": function($event) {
        _vm.modal.edit = true
      }
    }
  }, [_vm._v("修改密码")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("注销登录")])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.authorized) ? _c('div', [_c('div', {
    staticClass: "login-btn right"
  }, [_c('router-link', {
    attrs: {
      "to": "/auth/login"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/auth/register"
    }
  }, [_vm._v("注册")])], 1)]) : _vm._e()])])], 1)])])]), _vm._v(" "), (_vm.modal.edit) ? _c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          " + _vm._s(_vm.modal.title) + "\n          "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.clearEdit()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "360px"
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "input-item show-info"
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("注册邮箱:")]), _vm._v(" "), _c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "input-item clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 clearfix"
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-sm-7 n-p-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.verifyCode),
      expression: "verifyCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "blur": [function($event) {
        _vm.validateCode()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 n-p-r n-p-l"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button",
      "disabled": _vm.reset.disabled
    },
    on: {
      "click": function($event) {
        _vm.resendEmailCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.reset.text))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.code))])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "登录密码：6-16位，由字母、数字、特殊字符组成",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.confirm_password),
      expression: "confirm_password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "type": "password",
      "name": "confirm_password",
      "placeholder": "确认密码：6-16位，由字母、数字、特殊字符组成",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.password))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "btn btn-sm btn-primary m-r-md",
    on: {
      "click": function($event) {
        _vm.registerFunc()
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-sm btn-default",
    on: {
      "click": function($event) {
        _vm.clearEdit()
      }
    }
  }, [_vm._v("放弃修改")])])])])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69e76ef2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/navbar.vue
// module id = 490
// module chunks = 1